





































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import { WorkData } from "../types/models";

@Component
export default class Menu extends Vue {
  @Prop({ type: Boolean })
  showMenu: boolean = false;
  @Prop({ type: Boolean })
  showMenuSection: boolean = false;
  @Prop({ type: Object })
  workInfo!: WorkData;
  showWorkInfo: boolean = false;

  public toggleMenu(): void {
    this.$emit("toggleMenu");
  }

  public showGalleryDescription() {
    this.$emit("showWork");
  }

  public showOperationMordal() {}

  public showModeSelection() {}
}
